import $ from 'jquery';
import 'what-input';
window.jQuery = $;

import './lib/foundation-explicit-pieces';
import {editableSvg, isInViewport} from './lib/utilities';
import SlimSelect from 'slim-select';
import EventsCarousel from './blocks/custom/upcoming-events'
import ContentCarousel from './blocks/custom/content-carousel'
import ButtonReveal from './blocks/custom/button-reveal'
import SecondaryNav from './blocks/custom/secondary-nav'
import AccordionItem from './blocks/custom/accordion-item';
import { LightboxGallery, setFullWidthGallerySlider, MasonryGrid, setContainedGallerySlider } from './blocks/core/gallery';
import { FilterGallery, LightboxFilterGallery } from './blocks/custom/gallery-filters';
import { inViewportCounter } from "./utils/counter";
import Group from './blocks/core/group';
import './blocks/custom/map';
import Map from './blocks/custom/interactive-map';

import OffcanvasReservation from './global/offcanvas-reservation';

$(document).foundation();

$(function() {
    /* Replace all SVG images with inline SVG */
    editableSvg('img.editable-svg');
    document.querySelectorAll("[data-count]").forEach(inViewportCounter);

    /* Sticky header */
    window.onscroll = function() { stickyHeader() };
    const header = document.querySelector('.site-header');
    var sticky = header.offsetTop;

    function stickyHeader() {
        if (window.pageYOffset > sticky) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }
    /* end Sticky header */


    /* Hamburger click handle */
    $('.hamburger').on('click', function() {
        $('body').toggleClass('offcanvas-active');
      document.querySelector('.offcanvas-reservation.is-active')?.classList.remove('is-active');
    });

    /* Offcanvas close button handle */
    $('.off-canvas .close-button').on('click', function() {
        $('body').removeClass('offcanvas-active');
    });

    // Slim-select
    // const selects = document.querySelectorAll('.slim-selects')
    // selects.forEach((selectElement) => {
    //     new SlimSelect({
    //         select: selectElement
    //     })
    // })

    // scroll to top
    $(".back-to-top").on('click', function() {
        $("html, body").animate({scrollTop: 0}, 1500);
     });

    //global
    OffcanvasReservation();

    //  blocks
    LightboxGallery();
    setFullWidthGallerySlider();
    setContainedGallerySlider();
    FilterGallery();
    LightboxFilterGallery();
    MasonryGrid();
    EventsCarousel();
    SecondaryNav();
    ContentCarousel();
    ButtonReveal();
    AccordionItem();
    Group();
    Map();
});
